import {FileType, useCreateZyusetuMutation, ZyusetuType} from "@/graphql/graphql.ts";
import {ZyusetuCreationForm} from "@/components/pages/zyusetu-new/ZyusetuCreationForm.tsx";
import {ReactNode, useCallback, useState} from "react";
import toast from "react-hot-toast";
import {useNavigate} from "react-router-dom";
import dayjs from "dayjs";
import {Box, Chip, Container, Stack, Typography} from "@mui/material";
import {BuildingIcon, HouseIcon, LandPlotIcon} from "lucide-react";
import {FileUploader} from "@/components/pages/zyusetu-new/FileUploader.tsx";
import {FileTypeConfig} from "@/types/FileType.tsx";
import {MultiSelectorCard} from "@/components/input/MultiSelectorCard.tsx";

interface ZyusetuSalesType {
  type: string,
  label: string,
  icon: ReactNode
  onClick?: (salesType: ZyusetuSalesType) => void,
  fileType?: FileTypeConfig,
  isAvailable?: boolean
  tooltip?: string
}

export function SaleNewZyusetuPage() {
  
  const [templateId, setTemplateId] = useState<string | null>(null);
  const [zyusetuTitle, setZyusetuTitle] = useState<string | null>(`${dayjs().format("YYYY年MM月DD日")} - `);
  const [selectedFileType, setSelectedFileType] = useState<ZyusetuSalesType>();
  
  const AVAILABLE_ZYUSETU_SALES_TYPES: ZyusetuSalesType[] = [
    {
      type: "zyusetu-sale-building",
      label: "区分所有",
      icon: <BuildingIcon size={40} color={"#1a73e8"}/>,
      isAvailable: true,
      fileType: {
        type: FileType.ZyusetuResearchReport,
        zyusetuType: ZyusetuType.Sale
      } as FileTypeConfig
    },
    {
      type: "zyusetu-sale-house",
      label: "土地建物",
      icon: <HouseIcon size={40}/>,
      tooltip: "現在開発中です。しばらくお待ち下さい",
      onClick: undefined
    },
    {
      type: "zyusetu-sale-land",
      label: "土地",
      icon: <LandPlotIcon size={40}/>,
      tooltip: "現在開発中です。しばらくお待ち下さい",
      onClick: undefined
    },
  ]
  
  const nav = useNavigate();
  const createZyusetu = useCreateZyusetuMutation();
  
  const handleCreateZyusetu = useCallback(async (templateId: string, title: string) => {
    if (title.includes("/")) {
      toast.error("ファイル名に/を含めることはできません")
    } else {
      const zyusetu = await createZyusetu.mutateAsync({
        templateId: templateId,
        fileIds: [],
        title,
      });
      if (!zyusetu.createZyusetu) {
        toast.error("Failed to create zyusetu");
        return;
      }
      nav(`/zyusetu/${zyusetu.createZyusetu.id}/edit?ref=new`);
    }
  }, [nav, createZyusetu]);
  
  return <>
    
    <Container
      maxWidth={"lg"}
      sx={{
        width: "100%",
        height: "100%",
      }}
    >
      <Stack direction="row" alignItems="center" spacing={1} sx={{mb: 4, mt: 2}}>
        <Typography variant="pageTitle">
          STEP1: 作成する重説種類を選択してください
        </Typography>
        <Chip label={"売買 ※ベータ版"} color={'secondary'} sx={{fontWeight: "bold"}}/>
      </Stack>
      
      
      <MultiSelectorCard
        onSelect={(template) => {
          
          if (template.isAvailable)
            setSelectedFileType(template)
        }}
        options={AVAILABLE_ZYUSETU_SALES_TYPES}
        selected={selectedFileType}
      />
      <Box sx={{
        mt: 5
      }}>
        <Typography sx={{mb: 4, mt: 2}}>
          ※現在ベータ版です。ご利用の際はご注意ください。
        </Typography>
        {
          selectedFileType?.fileType && (
            <Stack spacing={3}>
              <FileUploader
                fileType={selectedFileType.fileType}
                onAnalyzeComplete={(_, _1) => {
                }}
                zyusetuType={ZyusetuType.Sale}
              />
              <ZyusetuCreationForm
                title={zyusetuTitle || ""}
                onTitleChange={setZyusetuTitle}
                zyusetuType={ZyusetuType.Sale}
                onSubmit={() => handleCreateZyusetu(templateId!, zyusetuTitle!)}
                disabled={!templateId || !zyusetuTitle}
                onTemplateSelect={setTemplateId}
              /></Stack>
          )
        }
      </Box>
    </Container>
  </>
}